<template>
  <div>
    <section class="orep-header mont">
      <section class="orep-badge text-uppercase">
        Insurance for Savvy Professionals
      </section>
      <section class="logo-wrapper">
        <img src="../../public/assets/images/logo@2.png" class="logo" alt="Logo">
        <span class="logo-text text-uppercase"></span>
      </section>
    </section>
    <section class="page-content">
      <div class="row">
        <div class="col-md-12">
          <form action>
            <article class="form-heading title-section auth-title-section form-section
             d-flex justify-content-center mb-0">
              <h1 class="form-title">User Portal</h1>
            </article>
            <article class="input-section form-section" >
              <div>
                <div class="row">
                  <div class="col-md-6 mb-3">
                    <label class="orep-label mb-2">
                      Company Name
                    </label>
                    <input name="company-name" class="orep-text-input w-100" disabled>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="orep-label mb-2">
                      Primary Contact
                    </label>
                    <input name="primary-contact" class="orep-text-input w-100" disabled>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-3">
                    <label class="orep-label mb-2">
                      Address
                    </label>
                    <input name="address" class="orep-text-input w-100" disabled>
                  </div>
                </div>
                <div class="row mt-5">
                  <div class="col-md-6 mb-3">
                    <label class="orep-label mb-2">
                      Policy
                    </label>
                    <input name="policy" class="orep-text-input w-100" disabled>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="orep-label mb-2">
                      Coverage Limits
                    </label>
                    <input name="coverage-limit" class="orep-text-input w-100" disabled>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-3">
                    <label class="orep-label mb-2">
                      Premium
                    </label>
                    <input name="premium" class="orep-text-input w-100" disabled>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="orep-label mb-2">
                      Policy Start Date
                    </label>
                    <input name="start-date" class="orep-text-input w-100" disabled>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-3">
                    <label class="orep-label mb-2">
                      Policy Expiration Date
                    </label>
                    <input name="expiration-date" class="orep-text-input w-100" disabled>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="orep-label mb-2">
                      Retroactive Date
                    </label>
                    <input name="retroactive-date" class="orep-text-input w-100" disabled>
                  </div>
                </div>
              </div>

              <div class="d-flex justify-content-center align-items-center mt-5">
                <button class="home-btn mont spaced mr-5">
                  RENEW
                </button>
                <button class="home-btn mont spaced">
                  <i class="fas fa-upload pull-right"></i>
                  UPLOAD DOCUMENTS
                </button>
              </div>
            </article>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

export default {
  name: 'home',
  data() {
    return {
      isActive: false,
    };
  },
  methods: {
    hamSpin() {
      this.isActive = !this.isActive;
    }
  },
};
</script>

<style scoped>
  .home-btn {
    width: 285px;
    text-align: center;
    height: 51px;
    border-radius: 5px;
    background-color: #5f6273;
    font-size: 16px;
    color: #fff;
    font-weight: 600;
    text-transform: uppercase;
    border: 0;
    cursor: pointer;
    margin: 1rem;
  }
</style>
